module.exports = "/images/side-publish-project-active.svg?62ac18a98961561bd667ba40a44158fc";